document.addEventListener("DOMContentLoaded", async () => {
  // ==================== VARIABLES ====================
  const asideItems = document.querySelectorAll(".aside-item");
  const activeFacetsContainer = document.querySelector(".active-eb-facets");
  const removeAllBtn = activeFacetsContainer.querySelector(".remove-all");
  const removeAllMb = document.querySelector(".remove-all-mobile");
  const allCheckboxes = document.querySelectorAll("input[type='checkbox']");
  const pageTypeCheckboxes = document.querySelectorAll('input[name="pagetype"]');
  const industryCheckboxes = document.querySelectorAll('input[name="industry"]');
  const styleCheckboxes = document.querySelectorAll('input[name="style"]');
  // ==================== SYNC CHECKBOX GROUP ====================
  industryCheckboxes.forEach(cb => {
    cb.addEventListener("change", () => {
      const value = cb.value;
      document
        .querySelectorAll(`input[name="industry"][value="${CSS.escape(value)}"]`)
        .forEach(other => {
          if (other !== cb) {
            other.checked = cb.checked;
          }
        });
    });
  });

  const sortSelect = document.getElementById("SortBy");
  const templateCountEl = document.getElementById("templateCount");
  const templateCountMb = document.querySelector(".count-mobile");
  const searchInput = document.getElementById("filterSearch");
  const itemsPerPage = 12;
  let filteredProducts = [];
  let currentPage = 1;
  let allProductsCache = null;

  // ==================== SIDEBAR TOGGLE ====================


  function initAsideFilter() {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      asideItems.forEach(item => item.classList.add("active"));
    }

    asideItems.forEach(item => {
      const title = item.querySelector(".aside-title");
      const content = item.querySelector(".aside-content");

      title.addEventListener("click", e => {
        e.stopPropagation();

        if (!isMobile) {
          asideItems.forEach(other => {
            if (other !== item) other.classList.remove("active");
          });
        }

        item.classList.toggle("active");
      });

      content.addEventListener("click", e => e.stopPropagation());
    });

    if (!isMobile) {
      document.addEventListener("click", () =>
        asideItems.forEach(item => item.classList.remove("active"))
      );
    }
  }

  initAsideFilter();
  window.addEventListener("resize", () => {
    asideItems.forEach(i => i.classList.remove("active"));
    initAsideFilter();
  });

  // ==================== FETCH FUNCTIONS ====================
  async function fetchCollectionProducts(url) {
    try {
      const res = await fetch(`${url}/products.json?limit=999`);
      const data = await res.json();
      return data.products || [];
    } catch (e) { return []; }
  }

  async function fetchAllProducts() {
    if (allProductsCache) return allProductsCache;
    try {
      const res = await fetch(`/products.json?limit=999`);
      const data = await res.json();
      allProductsCache = data.products || [];
      return allProductsCache;
    } catch (e) { return []; }
  }
 
  function uniqueProducts(arr) {
    const map = {};
    arr.forEach(p => map[p.handle] = p);
    return Object.values(map);
  }

  // ==================== ACTIVE FACETS ====================
  function renderActiveFacets() {
    activeFacetsContainer.querySelectorAll(".js-facet-remove.dynamic").forEach(chip => chip.remove());

    const checked = [...allCheckboxes].filter(cb => cb.checked);
    const seen = new Set();

    checked.forEach(cb => {
      const label = cb.parentElement.querySelector("label")?.innerText || cb.value;
      if (seen.has(label)) return;
      seen.add(label);

      const chipDiv = document.createElement("div");
      chipDiv.className = "js-facet-remove dynamic";
      chipDiv.innerHTML = `
              <a href="javascript:void(0);" class="active-eb-facets-button active-eb-facets-button--light">
                  <span class="active-eb-facets-button-inner eb-button eb-p">
                      ${label}
                      <span class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
                          </svg>
                      </span>
                      <span class="visually-hidden"></span>
                  </span>
              </a>
          `;
      chipDiv.addEventListener("click", () => {
        cb.checked = false;
        chipDiv.remove();
        handleFilter();
        updateCheckedCount();
      });
      activeFacetsContainer.insertBefore(chipDiv, removeAllBtn.parentElement);
    });
  }

  function getCheckedCount() {
    return document.querySelectorAll(".list-filter input[type='checkbox']:checked").length;
  }
  function updateCheckedCount() {
    const count = getCheckedCount();
    const countEl = document.querySelector(".filter-count");
    if (countEl) {
      countEl.textContent = count > 0 ? `(${count})` : "";
    }
  }

  allCheckboxes.forEach(cb => cb.addEventListener("change", () => {
    renderActiveFacets();
    handleFilter();
    updateCheckedCount();
  }));


  removeAllBtn.addEventListener("click", e => {
    e.preventDefault();
    allCheckboxes.forEach(cb => cb.checked = false);
    renderActiveFacets();
    handleFilter();
    updateCheckedCount();
  });
  removeAllMb.addEventListener("click", e => {
    e.preventDefault();
    allCheckboxes.forEach(cb => cb.checked = false);
    renderActiveFacets();
    handleFilter();
    updateCheckedCount();
  });
  updateCheckedCount();
  renderActiveFacets();

  // ==================== RENDER PRODUCTS + PAGINATION ====================
  // function addHoverEffect() {
  //     document.querySelectorAll('.eb-template-thumbnail').forEach(thumbnail => {
  //         const img = thumbnail.querySelector('img');
  //         if (!img) return;

  //         thumbnail.addEventListener('mouseenter', () => {
  //             const move = img.scrollHeight - thumbnail.offsetHeight;
  //             if (move > 0) {
  //                 img.style.transition = 'transform 8s linear';
  //                 img.style.transform = `translateY(-${move}px)`;
  //             }
  //         });

  //         thumbnail.addEventListener('mouseleave', () => {
  //             img.style.transition = 'none';
  //             img.style.transform = 'translateY(0)';
  //         });
  //     });
  // }
  function renderProductsPage(products) {
    const container = document.getElementById("ecombe-templates");
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const pageProducts = products.slice(start, end);
    const badgeTags = [
      "Recommend",
      "Cold",
      "Warm",
      "Hot"
    ];


    function getProductBadges(p) {
      return badgeTags
        .filter(tag => p.tags.some(t => t.includes(tag)))
        .map(tag => {
          const colorMap = {
            "Recommend": "#cdfee1",
            "Cold": "#02d1fa",
            "Warm": "#f4dabd",
            "Hot": "#ff3030"
          };
          const iconHTML = tag === "Recommend" ? `
                    <span class="w-4 h-4 block">
                        <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                          <path fill-rule="evenodd" d="M12.539 14.57a9.25 9.25 0 0 1-4.074-.838l-.307-.141a3.751 3.751 0 0 0-1.158-.32v-5.222a1.5 1.5 0 0 0 .15-.099 6.489 6.489 0 0 0 2.475-3.95 1.41 1.41 0 0 1 1.378 1.557l-.133 1.26a1.75 1.75 0 0 0 1.74 1.933h1.595c.758 0 1.342.67 1.239 1.42l-.338 2.449a2.25 2.25 0 0 1-2.176 1.942l-.391.01Zm-7.039-6.32h-1v5h1v-5Zm2.34 6.845a10.75 10.75 0 0 0 4.735.975l.391-.01a3.75 3.75 0 0 0 3.626-3.236l.337-2.448a2.75 2.75 0 0 0-2.724-3.126h-1.594a.25.25 0 0 1-.249-.276l.133-1.26a2.91 2.91 0 0 0-2.894-3.214h-.364c-.5 0-.928.357-1.017.849l-.055.303a4.989 4.989 0 0 1-1.915 3.098h-2c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h2.345c.324 0 .644.07.938.205l.307.14Z"></path>
                        </svg>
                    </span>` : "";

          return `
                <div class="eb-template-tag flex gap-2 flex-col">
                  <div class="eb-other-tag z-[2] bg-[${colorMap[tag]}] gap-1 flex items-center text-bm rounded-lg px-[.5rem] py-[.125rem] w-fit">
                      ${iconHTML}
                      ${tag}
                  </div>
                </div>
                `;
        }).join("");
    }


    if (products.length === 0) {
      container.innerHTML = `
        <div class="col-span-full flex flex-col gap-10 items-center">
         <div class="flex flex-col items-center gap-3"><svg class="icon icon-empty w-16 h-16" viewBox="0 0 60 61" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" d="M23.75 25.5a1.25 1.25 0 1 1-2.5 0m2.5 0a1.25 1.25 0 1 0-2.5 0m2.5 0h-2.5m17.5 0a1.25 1.25 0 1 1-2.5 0m2.5 0a1.25 1.25 0 1 0-2.5 0m2.5 0h-2.5m3.75 15c-2.28-3.036-5.91-5-10-5s-7.72 1.964-10.001 5M30 55.5v0c13.807 0 25-11.193 25-25v0c0-13.807-11.193-25-25-25v0c-13.807 0-25 11.193-25 25v0c0 13.807 11.193 25 25 25Z"></path>
    </svg><p class="font-bold text-2xl leading-none tracking-tight">No templates match those filters.</p>
                  <p>Use fewer filters or</p>
                </div>
                <button class="clear-all-btn w-fit px-4 py-2 eb-button-secondary text-white rounded-full ho">
                <span class="btn-text flex flex-row items-center gap-2"><svg class="icon icon-close-2 w-4 h-4" viewBox="0 0 14 15" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" d="m1 13.5 12-12m-12 0 12 12"></path>
    </svg>Clear all</span>
                </button>
                 <div>
      `;

      const clearBtn = container.querySelector(".clear-all-btn");
      clearBtn.addEventListener("click", () => {

        allCheckboxes.forEach(cb => cb.checked = false);

        const searchInput = document.getElementById("filterSearch");
        if (searchInput) searchInput.value = "";

        renderActiveFacets();
        updateCheckedCount();

        handleFilter();
      });

      const pagination = document.getElementById("pagination");
      if (pagination) pagination.style.display = "none";
      if (templateCountEl) templateCountEl.textContent = "0 template";
      if (templateCountMb) templateCountMb.textContent = "(0)";
      return;
    }

    container.innerHTML = pageProducts.map(p => {
      const badgesHTML = getProductBadges(p);

      return `
    <div class="template-card col-span-full sm:col-span-6 lg:col-span-4" style="opacity:0">
        <div class="eb-template-thumbnail rounded-xl border border-gray group relative">
           <div class="eb-template-tag absolute top-2 left-2 z-[2] flex gap-2 flex-wrap">
              ${badgesHTML}
            </div>
            <a href="/pages/templates/${p.handle}" class="w-full h-full block overflow-hidden">
                <img src="${p.images?.[0]?.src}&width=1000&height=1250&crop=top" alt="${p.title}" class="hidden md:block w-full rounded-xl object-cover">
                <img src="${p.images?.[1]?.src}&width=360&height=450&crop=top" alt="${p.title}" class="md:hidden w-full rounded-xl object-cover">
            </a>
        </div>
        <div class="template-info mt-4">
            <a href="/pages/templates/${p.handle}"><h3 class="font-bold">${p.title}</h3></a>
            <span class="text-bm text-black/60">${p.product_type}</span>
        </div>
    </div>`;
    }).join("");


    // stagger fade-in
    container.querySelectorAll('.template-card').forEach((card, index) => {
      setTimeout(() => card.classList.add('fade-in'), index * 50);
    });

    //  addHoverEffect();

    // update template count
    const totalTemplates = filteredProducts.length;
    const startIndex = start + 1;
    const endIndex = Math.min(end, totalTemplates);
    if (totalTemplates > itemsPerPage) {
      templateCountEl.textContent = `${startIndex}-${endIndex} of ${totalTemplates} templates`;
    } else {
      templateCountEl.textContent = `${totalTemplates} ${totalTemplates === 1 ? 'template' : 'templates'}`;
    }
    if (templateCountMb) {
      templateCountMb.textContent = `(${totalTemplates})`;
    }

    renderPagination(filteredProducts);
  }



  function renderPagination(products) {
    const container = document.getElementById("pagination");
    const totalPages = Math.ceil(products.length / itemsPerPage);
    container.innerHTML = "";

    if (totalPages <= 1) {
      container.style.display = "none";
      return;
    } else container.style.display = "flex";

    function scrollToTemplates() {
      const target = document.getElementById("ecombe-templates");
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - 300;
      window.scrollTo({ top, behavior: "smooth" });
    }

    function createBtn(page) {
      const btn = document.createElement("button");
      btn.textContent = page;
      btn.className = `px-3 py-1 border rounded ${page === currentPage ? "bg-main-color" : ""}`;
      btn.addEventListener("click", () => {
        currentPage = page;
        renderProductsPage(filteredProducts);
        scrollToTemplates();
      });
      return btn;
    }

    function addEllipsis() {
      const span = document.createElement("span");
      span.textContent = "...";
      span.className = "pagination-dots flex items-center justify-center w-8 h-10 px-2";
      container.appendChild(span);
    }

    // -------- PREVIOUS --------
    if (currentPage > 1) {
      const prev = document.createElement("button");
      prev.textContent = "Previous";
      prev.className = "page-prev px-3 py-1 border rounded";
      prev.addEventListener("click", () => {
        currentPage--;
        renderProductsPage(filteredProducts);
        scrollToTemplates();
      });
      container.appendChild(prev);
    }

    // -------- ALWAYS SHOW PAGE 1 --------
    container.appendChild(createBtn(1));

    // -------- LEFT ELLIPSIS --------
    if (currentPage > 3) addEllipsis();

    // -------- MIDDLE PAGES (current-1, current, current+1) --------
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      container.appendChild(createBtn(i));
    }

    // -------- RIGHT ELLIPSIS --------
    if (currentPage < totalPages - 2) addEllipsis();

    // -------- ALWAYS SHOW LAST PAGE --------
    if (totalPages > 1) {
      container.appendChild(createBtn(totalPages));
    }

    // -------- NEXT --------
    if (currentPage < totalPages) {
      const next = document.createElement("button");
      next.textContent = "Next";
      next.className = "page-next px-3 py-1 border rounded";
      next.addEventListener("click", () => {
        currentPage++;
        renderProductsPage(filteredProducts);
        scrollToTemplates();
      });
      container.appendChild(next);
    }
  }
  function levenshteinDistance(s1, s2) {
    if (s1.length < s2.length) [s1, s2] = [s2, s1];
    if (s2.length === 0) return s1.length;
    let prevRow = Array.from({ length: s2.length + 1 }, (_, i) => i);
    for (let i = 0; i < s1.length; i++) {
        let currRow = [i + 1];
        for (let j = 0; j < s2.length; j++) {
            let insertions = prevRow[j + 1] + 1;
            let deletions = currRow[j] + 1;
            let substitutions = prevRow[j] + (s1[i] === s2[j] ? 0 : 1);
            currRow.push(Math.min(insertions, deletions, substitutions));
        }
        prevRow = currRow;
    }
    return prevRow[s2.length];
}
  // ==================== HANDLE FILTER ====================
  window.handleFilter = async function () {
    const selectedPageTypes = [...pageTypeCheckboxes].filter(c => c.checked).map(c => c.value);
    const selectedIndustries = [...industryCheckboxes].filter(c => c.checked).map(c => c.value);
    const selectedStyles = [...styleCheckboxes].filter(c => c.checked).map(c => c.value);
    const searchQuery = searchInput?.value.trim().toLowerCase() || "";
    const overlay = document.querySelector(".loading-overlay");
    const spinner = document.querySelector(".eb-loading-spinner");

    if (overlay) overlay.classList.add("loading");
    if (spinner) spinner.classList.remove("hidden");

    setTimeout(async () => {
      let products = [];

      try {
        if (selectedPageTypes.length > 0) {
          let list = [];
          for (const url of selectedPageTypes) {
            const p = await fetchCollectionProducts(url);
            list = list.concat(p);
          }
          products = uniqueProducts(list);
        } else {
          products = await fetchAllProducts();
        }

        if (selectedIndustries.length > 0) {
          products = products.filter(p => selectedIndustries.includes(p.product_type));
        }

        if (selectedStyles.length > 0) {
          products = products.filter(p =>
            selectedStyles.some(style => p.tags.includes(`style_${style}`))
          );
        }
        if (searchQuery) {
          const searchTerms = searchQuery.toLowerCase().split(/\s+/).filter(t => t.length > 0);
        
          products = products.filter(p => {
            const titleWords = p.title.toLowerCase().split(/\s+/);
            const typeWords = (p.product_type?.toLowerCase() || "").split(/\s+/);
            const allWords = [...titleWords, ...typeWords];
        
            return searchTerms.every(term => {
              return allWords.some(word => {
                  if (word.includes(term)) return true; 
                  if (term.length > 3) {
                      const distance = levenshteinDistance(term, word);
                      return distance <= 1; 
                  }
                  return false;
              });
          });
          });
        
          products.sort((a, b) => {
            const q = searchQuery.toLowerCase();
            const aTitle = a.title.toLowerCase();
            const bTitle = b.title.toLowerCase();
            if (aTitle === q) return -1;
            if (bTitle === q) return 1;
        
            const aHasExactWord = aTitle.split(/\s+/).includes(q);
            const bHasExactWord = bTitle.split(/\s+/).includes(q);
            if (aHasExactWord !== bHasExactWord) return aHasExactWord ? -1 : 1;
        
            if (aTitle.startsWith(q) && !bTitle.startsWith(q)) return -1;
            if (!aTitle.startsWith(q) && bTitle.startsWith(q)) return 1;
        
            return 0;
          });
        }
        const sortValue = sortSelect.value;
        if (sortValue === "created-ascending") products.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        else if (sortValue === "created-descending") products.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        else if (sortValue === "title-ascending") products.sort((a, b) => a.title.localeCompare(b.title));
        else if (sortValue === "title-descending") products.sort((a, b) => b.title.localeCompare(a.title));
        if (!sortValue || sortValue === "created-descending") {
          products.sort((a, b) => {
            const getPriority = p => p.tags.includes("Recommend") ? 3
              : p.tags.includes("Trending") ? 2
                : p.tags.includes("Featured") ? 1
                  : 0;
            return getPriority(b) - getPriority(a);
          });
        }

        filteredProducts = products;
        currentPage = 1;
        renderProductsPage(filteredProducts);

      } finally {
        if (overlay) overlay.classList.remove("loading");
        if (spinner) spinner.classList.add("hidden");
      }
    }, 200);
  }



  // ==================== SORT SELECT ====================
  sortSelect.addEventListener("change", () => handleFilter());
  // debounce helper
  function debounce(func, wait = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  function applyFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    // pagetype
    const pageTypes = params.get("pagetype");
    if (pageTypes) {
      const values = pageTypes
        .split(",")
        .map(v => v.trim().toLowerCase());

      document
        .querySelectorAll('input[name="pagetype"]')
        .forEach(cb => {
          const collectionHandle = cb.value
            .replace("/collections/", "")
            .trim()
            .toLowerCase();

          cb.checked = values.includes(collectionHandle);
        });
      cleanURL();
    }


    const industries = params.get("industry");
    if (industries) {
      const values = industries.split(",");
      document
        .querySelectorAll('input[name="industry"]')
        .forEach(cb => {
          cb.checked = values.includes(cb.value);
        });
    }

    const styles = params.get("style");
    if (styles) {
      const values = styles.split(",");
      document
        .querySelectorAll('input[name="style"]')
        .forEach(cb => {
          cb.checked = values.includes(cb.value);
        });
    }
    const q = params.get("q");
    if (q && searchInput) {
      searchInput.value = decodeURIComponent(q);
      shouldCleanURL = true;
      cleanURL();
    }

    renderActiveFacets();
    updateCheckedCount();
  }
  function cleanURL() {
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, document.title, url.pathname);
  }

  searchInput?.addEventListener("input", debounce(() => {
    handleFilter();
  }, 500));
  // ==================== INIT ====================
  applyFiltersFromURL();
  handleFilter();

});
document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById("filterSearch");
  const resetBtn = document.querySelector(".search-reset");
  if (resetBtn && searchInput) {
    resetBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchInput.value = "";
      handleFilter();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const btnFilter = document.querySelector(".button-filter-mobile");
  const listFilter = document.querySelector(".list-filter");
  const overlay = document.querySelector(".background-overlay");
  const close = document.querySelector(".close-filter");
  const btnApply = document.querySelector(".btn-apply-filter");

  if (!btnFilter || !listFilter || !overlay) return;

  function toggleFilterMobile() {
    const isActive = listFilter.classList.toggle("open");
    document.body.style.overflow = isActive ? "hidden" : "";
  }

  function closeFilterMobile() {
    listFilter.classList.remove("open");
    document.body.style.overflow = "";
  }

  function handleMobile() {
    if (window.innerWidth < 768) {
      btnFilter.addEventListener("click", toggleFilterMobile);
      overlay.addEventListener("click", closeFilterMobile);
      close.addEventListener("click", closeFilterMobile);
      btnApply.addEventListener("click", closeFilterMobile);
    } else {
      btnFilter.removeEventListener("click", toggleFilterMobile);
      overlay.removeEventListener("click", closeFilterMobile);
      close.removeEventListener("click", closeFilterMobile);
      btnApply.removeEventListener("click", closeFilterMobile);
      closeFilterMobile();
    }
  }

  handleMobile();
  window.addEventListener("resize", handleMobile);
});
